import { Component, Input, Output, EventEmitter, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent {
  @Input() isOpen = false; // Состояние модального окна
  @Input() icon: string = '';
  @Input() title: string = '';
  @Input() text: string = '';
  @Input() primaryBtnText: string = '';
  @Input() secondaryBtnText: string = '';
  @Input() type: 'info' | 'error' | 'success' = 'success';

  @Output() primaryClick = new EventEmitter<void>();
  @Output() secondaryClick = new EventEmitter<void>();
  @Output() close = new EventEmitter<void>();

  // Закрытие по клику вне окна
  closeModal(event: Event) {
    if ((event.target as HTMLElement).classList.contains('modal-overlay')) {
      this.close.emit();
    }
  }

  // Закрытие на ESC
  @HostListener('document:keydown.escape', ['$event'])
  handleEscape() {
    if (this.isOpen) {
      this.close.emit();
    }
  }

  primaryAction() {
    this.primaryClick.emit();
    this.close.emit();
  }

  secondaryAction() {
    this.secondaryClick.emit();
    this.close.emit();
  }
}
